<template>
    <div class="container-fluid" id="directionsContainer">
        <h4>Get directions to:</h4>
        <p id="locationName">{{ props.locationName }}</p>
        <h4>From:</h4>
        <div id="directionOptions">
            <router-link 
                v-if="route.query.toType === 'R' && props.roomToRoom" class="directions-item"
                :to="getUrl('room')"
                @click="scrollBody"
            >
                <span>Another room in this building</span>
                <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            </router-link>

            <router-link class="directions-item"
                :to="getUrl('building')"
                @click="scrollBody"
            >
                <span>Another building</span>
                <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            </router-link>

            <router-link 
                v-if="geoLocationAvailable" class="directions-item"
                :to="getUrl('location')"
                @click="scrollBody"
            >
                <span>Current location</span>
                <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            </router-link>
        </div>
    </div>
</template>
<script setup>
import { useRoute } from 'vue-router'
import {useGeoCommon} from '@/composables/GeoCommon.js'
import { useMapCommon } from '../../composables/MapCommon.js'


const {geoLatitude, geoLongitude, geoLocationAvailable} = useGeoCommon()
const route = useRoute()
const {urlQueryPersist} = useMapCommon()


const props = defineProps({
  locationName: {
    type: String
  },
  roomToRoom: {
    type: Boolean,
    default: false
  }
})

/**
 * Return url based on the location type passed in. 
 * 
 * @param {string} locationType - The type of link to build
 * @returns {void}
 */
function getUrl(locationType){

    let url = ''
    const buildingQuery = '?buildingId=' + route.query.buildingId + '&toId=' + route.query.toId + '&toType=' + route.query.toType

    switch(locationType) {
        case 'room':
            url = 'roomfrom' + buildingQuery
            break;
        case 'building':
            url = 'buildingfrom' + buildingQuery
            break;
        case 'location':
            url = 'directions?toId=' + route.query.toId + '&toType=' + route.query.toType + '&geoLatitude=' + geoLatitude.value + '&geoLongitude=' + geoLongitude.value
            break;
    }

    url = urlQueryPersist(url, route)

    return url
}

/**
 * Allow body to scroll
 * 
 * @returns {void}
 */
function scrollBody() {
    const body = document.getElementsByTagName('body')
    body[0].style.overflow = ''
}

</script>
<style>
#directionsContainer {
    padding-top: 1rem;
}

#directionsContainer h4 {
    text-align: left;
    font-size: 20px;
}

#directionsContainer p#locationName {
    font-weight: bold;
    font-size: 20px;
    margin: 0.5rem 0px 0.5rem 1rem;
}

#directionOptions {
    margin-top: 1rem;
}

.directions-item {
    display:flex;
    align-items:center;
    font-size: 20px;
    padding: 1rem;
    border-top: solid 1px #ccc;
    color: var(--uog-dark-blue);
    text-decoration: none;
    transition: all 0.4s;
}

.directions-item span {
    flex-grow: 1;
}

.directions-item:hover {
    background-color: var(--uog-blue-10);
}

.directions-item:active {
    background-color: var(--uog-dark-blue);
    color:#fff;
}

.directions-item:last-child {
    border-bottom: solid 1px #ccc;
}
</style>